/** Translation keys used in Booking Engine */
export const enum DistributorTextKey {
    Add = 'Add',
    AddAnotherItem = 'AddAnotherItem',
    AddPromotionalCode = 'AddPromotionalCode',
    AddRoom = 'AddRoom',
    AddToCart = 'AddToCart',
    Added = 'Added',
    AddedCount = 'AddedCount',
    AdultPlural = 'AdultPlural',
    Amount = 'Amount',
    And = 'And',
    ApproximatePriceIn = 'ApproximatePriceIn',
    Arrival = 'Arrival',
    ArriveEarlier = 'ArriveEarlier',
    Availability = 'Availability',
    AvailableSpaceCount = 'AvailableSpaceCount',
    BookAnotherStay = 'BookAnotherStay',
    BookNow = 'BookNow',
    BookOnlineBonuses = 'BookOnlineBonuses',
    BookOnlineGetMore = 'BookOnlineGetMore',
    BookerDisabled = 'BookerDisabled',
    BookerEnabled = 'BookerEnabled',
    Booking = 'Booking',
    BookingConfirmationMessage = 'BookingConfirmationMessage',
    BookingNotes = 'BookingNotes',
    CalendarDateNotAvailable = 'CalendarDateNotAvailable',
    CalendarRestrictionMaxAdvance = 'CalendarRestrictionMaxAdvance',
    CalendarRestrictionMaxAdvanceShortened = 'CalendarRestrictionMaxAdvanceShortened',
    CalendarRestrictionMaxLengthDays = 'CalendarRestrictionMaxLengthDays',
    CalendarRestrictionMaxLengthDaysShortened = 'CalendarRestrictionMaxLengthDaysShortened',
    CalendarRestrictionMaxLengthNights = 'CalendarRestrictionMaxLengthNights',
    CalendarRestrictionMaxLengthNightsShortened = 'CalendarRestrictionMaxLengthNightsShortened',
    CalendarRestrictionMinAdvance = 'CalendarRestrictionMinAdvance',
    CalendarRestrictionMinAdvanceShortened = 'CalendarRestrictionMinAdvanceShortened',
    CalendarRestrictionMinLengthDays = 'CalendarRestrictionMinLengthDays',
    CalendarRestrictionMinLengthDaysShortened = 'CalendarRestrictionMinLengthDaysShortened',
    CalendarRestrictionMinLengthNights = 'CalendarRestrictionMinLengthNights',
    CalendarRestrictionMinLengthNightsShortened = 'CalendarRestrictionMinLengthNightsShortened',
    CardIssuerMayApplyForeignTransactionFee = 'CardIssuerMayApplyForeignTransactionFee',
    CategoriesWithAlternativeTimesBody = 'CategoriesWithAlternativeTimesBody',
    CategoriesWithAlternativeTimesButton = 'CategoriesWithAlternativeTimesButton',
    CategoriesWithAlternativeTimesHeader = 'CategoriesWithAlternativeTimesHeader',
    CategoriesWithoutAvailability = 'CategoriesWithoutAvailability',
    Checkout = 'Checkout',
    ChildPlural = 'ChildPlural',
    CityTaxExcluded = 'CityTaxExcluded',
    CityTaxIncluded = 'CityTaxIncluded',
    ClearBasket = 'ClearBasket',
    ClearDates = 'ClearDates',
    Close = 'Close',
    ComparePrices = 'ComparePrices',
    Confirm = 'Confirm',
    ConfirmAndPayNow = 'ConfirmAndPayNow',
    Confirmation = 'Confirmation',
    ConfirmationNumber = 'ConfirmationNumber',
    ConnectionErrorMessage = 'ConnectionErrorMessage',
    ContactAndPaymentDetails = 'ContactAndPaymentDetails',
    ContactDetails = 'ContactDetails',
    ContactUsMessage = 'ContactUsMessage',
    Continue = 'Continue',
    CreatingReservation = 'CreatingReservation',
    CurrencySelectDialogTitleAllCurrencies = 'CurrencySelectDialogTitleAllCurrencies',
    CurrencySelectDialogTitleSuggestedCurrencies = 'CurrencySelectDialogTitleSuggestedCurrencies',
    Date = 'Date',
    DateAndTime = 'DateAndTime',
    DateIntervalExceededErrorMessage = 'DateIntervalExceededErrorMessage',
    DateIsBookedOut = 'DateIsBookedOut',
    DateIsInPast = 'DateIsInPast',
    DatePlural = 'DatePlural',
    Dates = 'Dates',
    DayFriday = 'DayFriday',
    DayMonday = 'DayMonday',
    DayPluralSelected = 'DayPluralSelected',
    DaySaturday = 'DaySaturday',
    DayShortFriday = 'DayShortFriday',
    DayShortMonday = 'DayShortMonday',
    DayShortSaturday = 'DayShortSaturday',
    DayShortSunday = 'DayShortSunday',
    DayShortThursday = 'DayShortThursday',
    DayShortTuesday = 'DayShortTuesday',
    DayShortWednesday = 'DayShortWednesday',
    DaySunday = 'DaySunday',
    DayThursday = 'DayThursday',
    DayTuesday = 'DayTuesday',
    DayWednesday = 'DayWednesday',
    DepartLater = 'DepartLater',
    Departure = 'Departure',
    Dismiss = 'Dismiss',
    DistributorEnterpriseFatalErrorMessage = 'DistributorEnterpriseFatalErrorMessage',
    DistributorFatalErrorMessage = 'DistributorFatalErrorMessage',
    DistributorQuotaExceededErrorMessage = 'DistributorQuotaExceededErrorMessage',
    DistributorSessionExpiredErrorMessage = 'DistributorSessionExpiredErrorMessage',
    DistributorTimeoutErrorMessage = 'DistributorTimeoutErrorMessage',
    Edit = 'Edit',
    Email = 'Email',
    EnhanceYourStay = 'EnhanceYourStay',
    ExceedsMaxAdultCountPerBookingWarningMessage = 'ExceedsMaxAdultCountPerBookingWarningMessage',
    ExceedsMaxAdultCountPerBookingWarningTitle = 'ExceedsMaxAdultCountPerBookingWarningTitle',
    ExcludingTaxes = 'ExcludingTaxes',
    ExcludingTaxesFees = 'ExcludingTaxesFees',
    ExpiredReservationLinkMessage = 'ExpiredReservationLinkMessage',
    ExtraBeds = 'ExtraBeds',
    FeesExcluded = 'FeesExcluded',
    FeesIncluded = 'FeesIncluded',
    FinishBooking = 'FinishBooking',
    FinishOrClearBookingMessage = 'FinishOrClearBookingMessage',
    FirstName = 'FirstName',
    Free = 'Free',
    FreeCancellation = 'FreeCancellation',
    FreeCancellationOnly = 'FreeCancellationOnly',
    FreeCancellationUntilExtended = 'FreeCancellationUntilExtended',
    FromDate = 'FromDate',
    FromPrice = 'FromPrice',
    Gallery = 'Gallery',
    GuestDetails = 'GuestDetails',
    GuestPluralSelected = 'GuestPluralSelected',
    GuestsGeneralTermsAndConditions = 'GuestsGeneralTermsAndConditions',
    HideRateComparison = 'HideRateComparison',
    HintContactEnterprise = 'HintContactEnterprise',
    HotelFullErrorMessage = 'HotelFullErrorMessage',
    HourPlural = 'HourPlural',
    HourPluralSelected = 'HourPluralSelected',
    HourlyBookingEngineNoTimeAvailableErrorBannerPrimaryText = 'HourlyBookingEngineNoTimeAvailableErrorBannerPrimaryText',
    HourlyBookingEngineNoTimeAvailableErrorBannerSecondaryText = 'HourlyBookingEngineNoTimeAvailableErrorBannerSecondaryText',
    HourlyBookingEngineSelectEndTimeHeader = 'HourlyBookingEngineSelectEndTimeHeader',
    HourlyBookingEngineSelectStartTimeHeader = 'HourlyBookingEngineSelectStartTimeHeader',
    IAgreeTo = 'IAgreeTo',
    InPropertyCurrency = 'InPropertyCurrency',
    InYourCurrency = 'InYourCurrency',
    IncludedInRate = 'IncludedInRate',
    IncludingTaxes = 'IncludingTaxes',
    IncorrectIframeDialogMessage = 'IncorrectIframeDialogMessage',
    InvalidAvailabilityBlockLinkMessage = 'InvalidAvailabilityBlockLinkMessage',
    LastName = 'LastName',
    LegalStatementOrderObligingToPay = 'LegalStatementOrderObligingToPay',
    Less = 'Less',
    LinkTo = 'LinkTo',
    LoadingAvailability = 'LoadingAvailability',
    LoadingBookingEngine = 'LoadingBookingEngine',
    Location = 'Location',
    LocationsWithoutAvailability = 'LocationsWithoutAvailability',
    MainContent = 'MainContent',
    MaxPersons = 'MaxPersons',
    MewsPrivacyPolicy = 'MewsPrivacyPolicy',
    MonthApril = 'MonthApril',
    MonthAugust = 'MonthAugust',
    MonthDecember = 'MonthDecember',
    MonthFebruary = 'MonthFebruary',
    MonthJanuary = 'MonthJanuary',
    MonthJuly = 'MonthJuly',
    MonthJune = 'MonthJune',
    MonthMarch = 'MonthMarch',
    MonthMay = 'MonthMay',
    MonthNovember = 'MonthNovember',
    MonthOctober = 'MonthOctober',
    MonthSeptember = 'MonthSeptember',
    MonthShortApril = 'MonthShortApril',
    MonthShortAugust = 'MonthShortAugust',
    MonthShortDecember = 'MonthShortDecember',
    MonthShortFebruary = 'MonthShortFebruary',
    MonthShortJanuary = 'MonthShortJanuary',
    MonthShortJuly = 'MonthShortJuly',
    MonthShortJune = 'MonthShortJune',
    MonthShortMarch = 'MonthShortMarch',
    MonthShortMay = 'MonthShortMay',
    MonthShortNovember = 'MonthShortNovember',
    MonthShortOctober = 'MonthShortOctober',
    MonthShortSeptember = 'MonthShortSeptember',
    More = 'More',
    NameOnCard = 'NameOnCard',
    Nationality = 'Nationality',
    NewBooking = 'NewBooking',
    Next = 'Next',
    NextImage = 'NextImage',
    NextMonth = 'NextMonth',
    NightPluralSelected = 'NightPluralSelected',
    NoAvailabilityMessage = 'NoAvailabilityMessage',
    NoAvailableDates = 'NoAvailableDates',
    NoDataAvailable = 'NoDataAvailable',
    NoFreeCancellationRatesAreAvailable = 'NoFreeCancellationRatesAreAvailable',
    NoFreeDates = 'NoFreeDates',
    NoMoreAvailabilityMessage = 'NoMoreAvailabilityMessage',
    NonEmptyBookingMessage = 'NonEmptyBookingMessage',
    NonRefundable = 'NonRefundable',
    NotEnoughSpaceForGuests = 'NotEnoughSpaceForGuests',
    NotEverybodyAccommodatedDialogBody = 'NotEverybodyAccommodatedDialogBody',
    NotEverybodyAccommodatedDialogProceedAnyway = 'NotEverybodyAccommodatedDialogProceedAnyway',
    NotEverybodyAccommodatedDialogTitle = 'NotEverybodyAccommodatedDialogTitle',
    NotEverybodyAccommodatedWarning = 'NotEverybodyAccommodatedWarning',
    Occupancy = 'Occupancy',
    Of = 'Of',
    Ok = 'Ok',
    OptionalGuestEmailHint = 'OptionalGuestEmailHint',
    Or = 'Or',
    OtherSuggestions = 'OtherSuggestions',
    OurPrice = 'OurPrice',
    PartiallyRefundable = 'PartiallyRefundable',
    PartiallyRefundableUntilExtended = 'PartiallyRefundableUntilExtended',
    Payment = 'Payment',
    PaymentCardCVV = 'PaymentCardCVV',
    PaymentCardExpiration = 'PaymentCardExpiration',
    PaymentCardNumber = 'PaymentCardNumber',
    PaymentConfirmed = 'PaymentConfirmed',
    PaymentFailed = 'PaymentFailed',
    PaymentFailedHoldingReservation = 'PaymentFailedHoldingReservation',
    PaymentProcessingHoldingReservation = 'PaymentProcessingHoldingReservation',
    PaymentSubmitted = 'PaymentSubmitted',
    PaymentSuccessConfirmationMessage = 'PaymentSuccessConfirmationMessage',
    PerNight = 'PerNight',
    PersonCount = 'PersonCount',
    PhoneNumber = 'PhoneNumber',
    PlaceholderIsUnavailable = 'PlaceholderIsUnavailable',
    PreparingSecureCheckout = 'PreparingSecureCheckout',
    PreviousImage = 'PreviousImage',
    PreviousMonth = 'PreviousMonth',
    PriceLabelVatAndCityTaxExcluded = 'PriceLabelVatAndCityTaxExcluded',
    PriceLabelVatAndCityTaxIncluded = 'PriceLabelVatAndCityTaxIncluded',
    PriceLabelVatExcludedCityTaxIncluded = 'PriceLabelVatExcludedCityTaxIncluded',
    PriceLabelVatIncludedCityTaxExcluded = 'PriceLabelVatIncludedCityTaxExcluded',
    ProductPlural = 'ProductPlural',
    ProductsAndExtras = 'ProductsAndExtras',
    Progress = 'Progress',
    PromotionCode = 'PromotionCode',
    PromotionRatePlural = 'PromotionRatePlural',
    Properties = 'Properties',
    Property = 'Property',
    PropertyPrivacyPolicy = 'PropertyPrivacyPolicy',
    PropertyTermsAndConditions = 'PropertyTermsAndConditions',
    PublicRatePlural = 'PublicRatePlural',
    Rate = 'Rate',
    RatePlural = 'RatePlural',
    Rates = 'Rates',
    RecalculatingPrice = 'RecalculatingPrice',
    Refresh = 'Refresh',
    RemoveFromCart = 'RemoveFromCart',
    Required = 'Required',
    ReservationConfirmedPaymentPastDue = 'ReservationConfirmedPaymentPastDue',
    ReservationSummaryTotalBarCardTotalAmount = 'ReservationSummaryTotalBarCardTotalAmount',
    RestrictionMaxAdvanceHintMessage = 'RestrictionMaxAdvanceHintMessage',
    RestrictionMaxLengthHintMessage = 'RestrictionMaxLengthHintMessage',
    RestrictionMinAdvanceHintMessage = 'RestrictionMinAdvanceHintMessage',
    RestrictionMinLengthHintMessage = 'RestrictionMinLengthHintMessage',
    RestrictionUniversalHintMessage = 'RestrictionUniversalHintMessage',
    SearchingOtherDates = 'SearchingOtherDates',
    SeeRateComparison = 'SeeRateComparison',
    SelectAnotherCategory = 'SelectAnotherCategory',
    SelectCategory = 'SelectCategory',
    SelectDate = 'SelectDate',
    SelectDatesTitle = 'SelectDatesTitle',
    SelectLocation = 'SelectLocation',
    SelectRate = 'SelectRate',
    SelectTime = 'SelectTime',
    SelectYourCurrency = 'SelectYourCurrency',
    SelectYourLanguage = 'SelectYourLanguage',
    SendMarketingEmailsTemplate = 'SendMarketingEmailsTemplate',
    SendMarketingEmailsTemplateEnterpriseAndChain = 'SendMarketingEmailsTemplateEnterpriseAndChain',
    ServiceFeeWillBeAddedToFinalPrice = 'ServiceFeeWillBeAddedToFinalPrice',
    ShowLess = 'ShowLess',
    ShowLessProducts = 'ShowLessProducts',
    ShowMore = 'ShowMore',
    ShowMoreProducts = 'ShowMoreProducts',
    ShowProperty = 'ShowProperty',
    ShowRates = 'ShowRates',
    SiteNavigation = 'SiteNavigation',
    SkipTo = 'SkipTo',
    Sleeps = 'Sleeps',
    SpaceCategories = 'SpaceCategories',
    SpaceImage = 'SpaceImage',
    SubstitutableDayPlural = 'SubstitutableDayPlural',
    SubstitutableNightPlural = 'SubstitutableNightPlural',
    Summary = 'Summary',
    SurchargeFeeMessage = 'SurchargeFeeMessage',
    TaxIncluded = 'TaxIncluded',
    TaxPlural = 'TaxPlural',
    TaxPluralIncludedInPrice = 'TaxPluralIncludedInPrice',
    TermsAndConditionsSMSAcceptance = 'TermsAndConditionsSMSAcceptance',
    Time = 'Time',
    TimeOnDate = 'TimeOnDate',
    Toolbar = 'Toolbar',
    Total = 'Total',
    TryAgain = 'TryAgain',
    TryOtherDates = 'TryOtherDates',
    Unavailable = 'Unavailable',
    Until = 'Until',
    UntilDate = 'UntilDate',
    UpdatePaymentStatus = 'UpdatePaymentStatus',
    UpdatingWithEllipsis = 'UpdatingWithEllipsis',
    ValidateAgreement = 'ValidateAgreement',
    ValidateBookerEmail = 'ValidateBookerEmail',
    ValidateCVV = 'ValidateCVV',
    ValidatePaymentCard = 'ValidatePaymentCard',
    ValidatePaymentCardExpiration = 'ValidatePaymentCardExpiration',
    ValidatePaymentCardType = 'ValidatePaymentCardType',
    ValidatePhoneNumber = 'ValidatePhoneNumber',
    ValidationErrorMessage = 'ValidationErrorMessage',
    VerifyPaymentCardProgress = 'VerifyPaymentCardProgress',
    ViewAllPhotos = 'ViewAllPhotos',
    WeWillSendConfirmationToThisEmail = 'WeWillSendConfirmationToThisEmail',
    YouWillPayAmount = 'YouWillPayAmount',
    YouWillPayIn = 'YouWillPayIn',
    YouWillPayLater = 'YouWillPayLater',
    YouWillPayNow = 'YouWillPayNow',
    YourDetails = 'YourDetails',
    ZeroAdultsSelectedDialogBody = 'ZeroAdultsSelectedDialogBody',
    ZeroAdultsSelectedDialogTitle = 'ZeroAdultsSelectedDialogTitle',
    ZeroAdultsSelectedSummaryDialogBackButton = 'ZeroAdultsSelectedSummaryDialogBackButton',
    ZeroAdultsSelectedSummaryDialogBody = 'ZeroAdultsSelectedSummaryDialogBody',
    ZeroAdultsSelectedSummaryDialogTitle = 'ZeroAdultsSelectedSummaryDialogTitle',
}
